module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABPUlEQVRIx2NgmOdJCUrZZPruvOT2GQJykswM6IBcQ+WWOG8/rPLumGhKMCcDdkB9x5JrNNyxqSHcuA1lAFtJrmNnz56tqqpaWVlpb2+PZi4wiIB2M5Adss3Nzf/+/fv06RMjIyOyY4EW/zwu/iBWgYG8kC0qKnr79u3///9///49ffp0ZMd+mCt1RUP1nKAaA9nJgIWF5eHDh7a2trq6upoq/HDHAg2FIAZKkkF2djamYwkYTUSaRQ9ZZENxGk1cmsXpWOxGwx1bnKwgISEB1C8vL0+qY7EYjexYYBTdvn27s7Nzz549pDoWxWjMkJWRkfn+/Tswbc2dO5dUxyKMxgxZUVHRpUuXAl0NzBGXL1/GnwzwGY0rGcjJyW3bto0MxyKMxpMMNDQ0yHAsUliTlWbJN5oSx+I0mnLHwhEASmH91Ay6QGMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/kn.png
// module id = 855
// module chunks = 0